import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { TypeORMError } from "./TypeORMError";
import { ObjectUtils } from "../util/ObjectUtils";
import { InstanceChecker } from "../util/InstanceChecker";
/**
 * Thrown when no result could be found in methods which are not allowed to return undefined or an empty set.
 */
export var EntityNotFoundError = /*#__PURE__*/function (_TypeORMError) {
  _inherits(EntityNotFoundError, _TypeORMError);
  var _super = _createSuper(EntityNotFoundError);
  function EntityNotFoundError(entityClass, criteria) {
    var _this;
    _classCallCheck(this, EntityNotFoundError);
    _this = _super.call(this);
    _this.message = "Could not find any entity of type \"".concat(_this.stringifyTarget(entityClass), "\" ") + "matching: ".concat(_this.stringifyCriteria(criteria));
    return _this;
  }
  _createClass(EntityNotFoundError, [{
    key: "stringifyTarget",
    value: function stringifyTarget(target) {
      if (InstanceChecker.isEntitySchema(target)) {
        return target.options.name;
      } else if (typeof target === "function") {
        return target.name;
      } else if (ObjectUtils.isObject(target) && "name" in target) {
        return target.name;
      } else {
        return target;
      }
    }
  }, {
    key: "stringifyCriteria",
    value: function stringifyCriteria(criteria) {
      try {
        return JSON.stringify(criteria, null, 4);
      } catch (e) {}
      return "" + criteria;
    }
  }]);
  return EntityNotFoundError;
}(TypeORMError);